import React, { forwardRef } from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import PlacesAutocomplete from 'react-places-autocomplete';

import { MuiBaseTextFiled } from '@shared/ui-kit';

import { PlaceAutocompleteItemContainer } from './MuiLocationInput.style';

type MuiLocationInputProps = {
  value?: string;
  onSearchError?: () => void;
  handleSelect?: (data: string) => void;
  onChange?: (e: any) => void;
  placeholder?: string;
  label?: string;
  inputVariant?: 'outline' | 'text';
  isRequired?: boolean;

  name: string;
  isError?: boolean;
  errorMessage?: string;
};

export const MuiLocationInput = forwardRef<HTMLHeadingElement, MuiLocationInputProps>((props, ref) => {
  const {
    value,
    placeholder,
    label,
    onSearchError,
    inputVariant,
    handleSelect,
    onChange,
    name,
    isError,
    errorMessage,
    isRequired,
  } = props;
  const theme = useTheme();
  return (
    <PlacesAutocomplete value={value} onChange={onChange} onSelect={handleSelect} onError={onSearchError}>
      {({ getInputProps, suggestions, getSuggestionItemProps }) => (
        <Box position="relative">
          <MuiBaseTextFiled
            {...getInputProps({ placeholder, label })}
            name={name}
            value={value}
            isError={isError}
            inputVariant={inputVariant}
            errorMessage={errorMessage}
            isRequired={isRequired}
            isClearable
            isOffAutocomplete
            ref={ref}
            inputStyles={{
              color: theme.palette.case.neutral.n900,
              ...theme.typography.t14m,
            }}
          />

          {suggestions?.length ? (
            <Box
              sx={{
                backgroundColor: theme.palette.case.background,
                borderRadius: '8px',
                border: !!suggestions.length ? `1px solid ${theme.palette.case.neutral.n200}` : 'none',
                marginTop: '16px',
                padding: '4px',
                position: 'absolute',
                zIndex: 99,
              }}
            >
              {/*{loading && <div>Loading...</div>}*/}

              {suggestions.map((suggestion) => {
                return (
                  <PlaceAutocompleteItemContainer
                    {...getSuggestionItemProps(suggestion, {})}
                    key={suggestion.description}
                  >
                    <Typography variant="t14r">{suggestion.description}</Typography>
                  </PlaceAutocompleteItemContainer>
                );
              })}
            </Box>
          ) : (
            <></>
          )}
        </Box>
      )}
    </PlacesAutocomplete>
  );
});
